import React, { useContext, useState } from 'react';
import { Button, TabsProps } from 'antd';

import IBTooltip from '@totem/components/common/helpTooltips/IBTooltip';
import TicketingConfigurationContainer from '@totem/components/ticketing/configuration/ticketingConfigurationContainer';
import TicketListContainer, {
  containerConfiguration,
} from '@totem/components/ticketing/listContainer/TicketListContainer';
import TicketsFavoritesTable from '@totem/components/ticketing/myTickets/favorites/favoritesTable';
import MyTaskKanbanBoard from '@totem/components/ticketing/myTickets/myTasks/myTaskKanbanBoard';
import MyTicketsContext from '@totem/components/ticketing/myTickets/myTicketsContext';
import MyTicketsTable from '@totem/components/ticketing/myTickets/myTicketsTable';
import TicketEntryDialog from '@totem/components/ticketing/ticket/ticketEntryDialog';
import IBTabs from '@totem/components/ui_components/antDesignOverrides/IBTabs';
import FilterChips from '@totem/components/ui_components/reportSettings/filterChips';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { TICKETS_ENDPOINT } from '@totem/utilities/endpoints';

const MyTicketsLayout = () => {
  const { userProfile } = useContext(UserProfileContext);
  const { onAction } = useContext(MyTicketsContext);
  const [showNewTicketModal, setShowNewTicketModal] = useState<boolean>(false);
  const tabItems: TabsProps['items'] = [
    {
      key: 'tickets',
      label: 'My Tickets',
      children: (
        <div>
          <FilterChips />
          <MyTicketsTable />
        </div>
      ),
    },
    {
      key: 'favorites',
      label: 'My Favorites',
      children: (
        <InputContainer
          filterConfig={containerConfiguration}
          defaultSort={{
            field: 'createdAt',
            direction: 'descend',
          }}
          defaultFilters={[
            {
              field: 'status',
              values: ['OPEN', 'RESOLVED'],
            },
          ]}
          componentKey={'dashboard.myTickets.favorites'}
        >
          <TicketListContainer ticketEndPoint={`${TICKETS_ENDPOINT}/favorites`}>
            <TicketsFavoritesTable />
          </TicketListContainer>
        </InputContainer>
      ),
    },
    {
      key: 'tasks',
      label: 'My Tasks',
      children: (
        <div>
          <FilterChips />
          <MyTaskKanbanBoard />
        </div>
      ),
    },
  ];

  const handleTicketCreateClosed = (ticketCreated: boolean) => {
    setShowNewTicketModal(false);
    if (ticketCreated) {
      onAction('refresh', null);
    }
  };

  const getTabBarExtraContent = () => {
    if (permissions.ticketingCreator.hasPermissions(userProfile)) {
      return (
        <TicketingConfigurationContainer>
          &nbsp;&nbsp;&nbsp;
          <IBTooltip content={permissions.ticketingCreator.tooltip}>
            <Button type="primary" onClick={() => setShowNewTicketModal(true)}>
              New Ticket
            </Button>
          </IBTooltip>
          {showNewTicketModal && (
            <TicketEntryDialog
              visible={showNewTicketModal}
              onClose={handleTicketCreateClosed}
            />
          )}
        </TicketingConfigurationContainer>
      );
    }

    return <span />;
  };

  return (
    <IBTabs
      defaultActiveKey={'tickets'}
      items={tabItems}
      tabBarExtraContent={getTabBarExtraContent()}
    />
  );
};

export default MyTicketsLayout;
